import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

// * https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
// * https://github.com/arkon/ng-click-outside
// * https://www.bennadel.com/blog/3009-tracking-click-events-outside-the-current-component-in-angular-2-beta-1.htm
@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective
{
    @Output() public clickOutside: EventEmitter<null> = new EventEmitter();

    constructor (private elementRef: ElementRef)
    {
    }

    @HostListener('document:click', ['$event'])
    public onClick ($event: MouseEvent)
    {
        const divPopin = this.elementRef.nativeElement.firstChild;
        const width = divPopin.clientWidth;
        const fullWidth = divPopin.offsetLeft; // ????

        // outside si clickX entre 0 et fullWidth - width;
        const outsideX = fullWidth - width;
        const clickedOutside = $event.x < outsideX;

        if (clickedOutside)
        {
            this.clickOutside.emit();
        }
    }
}
